<template>
  <v-card
    v-hover="{ '.item-title': 'primary--text' }"
    class="grey--text position-relative item"
    :to="item.to"
    flat
    tile
  >
    <img
      v-if="item.img"
      :src="files + item.img"
      class="d-block item-img"
      width="100%"
    />

    <v-sheet
      color="transparent"
      height="82px"
      class="
        d-flex
        align-center
        justify-center
        text-body-2 text-md-subtitle-2 text-lg-h6 text-center
        font-weight-bold
        px-3 px-md-4
        item-title
      "
    >
      <span class="font-secondary">
        {{ item.title }}
      </span>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid var(--v-grey-lighten2) !important;

  &-img {
    aspect-ratio: 264 / 210;
    border-bottom: 1px solid var(--v-grey-lighten4) !important;
    object-fit: cover;
    -o-object-fit: cover;
  }

  &-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
